require('./uploadDocumentModal.i18n.json');
require('./uploadDocumentModal.tpl.html');

/*@ngInject*/
const UploadDocumentModalController = function ($rootScope, $scope, $timeout, coreConstant, localization, attachmentUtil) {

    let translations;

    localization.getTranslationsByKeys([this.translationsKey, 'uploadDocument']).then(function (result) {
        translations = result;

        $scope.viewModel = {
            title: translations.title,
            cancelButton: translations.cancelButton,
            uploadFileButton: translations.uploadFileButton,
            or: translations.or,
            dragAndDrop: translations.dragAndDrop,
            attachment: {},
            typeDataItems: null,
            uploadedFile: null,
            chooseFileString: translations.chooseFile,
            nameEditMode: false,
            editNameIconText: translations.editFilename
        };

        $scope.onCancel = function () {
            $scope.$dismiss();
        };
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
        if (file) {
            storeUploadedFile(file);
        }
    });

    $scope.fileSelected = function (file) {
        if (file) {
            storeUploadedFile(file);
        }
    };

    function storeUploadedFile(uploadedFile) {
        const allowFile = attachmentUtil.validateAttachmentForUMStudio(uploadedFile, _.get(translations, 'unacceptableType'));
        if (allowFile) {
            $timeout(function () {
                $scope.viewModel.uploadedFile = uploadedFile;
                if (!$scope.viewModel.attachment) {
                    $scope.viewModel.attachment = {};
                }
                $scope.viewModel.attachment.name = uploadedFile.name;
                $scope.viewModel.attachment.size = uploadedFile.size;
            }, 0);
        }
    }

    $scope.onUploadFileClicked = function () {
        $rootScope.$broadcast(coreConstant.event.FILE_UPLOADED, {
            uploadedFile: $scope.viewModel.uploadedFile,
            name: $scope.viewModel.attachment.name
        });
        $scope.$close();
    };

    $scope.canEnableConfirmButton = function () {
        return $scope.viewModel.attachment.name;
    };

    $scope.onUpdateField = function () {
        if ($scope.viewModel.attachment && $scope.viewModel.attachment.id) {
            $scope.updateAttachment($scope.viewModel.attachment);
        }
        $scope.viewModel.nameEditMode = false;
    };

    $scope.activateEditfilename = function () {
        $scope.viewModel.nameEditMode = true;
    };

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('ums.configuration')
    .controller('uploadDocumentModalController', UploadDocumentModalController);
